import { PropsWithChildren, ReactNode } from "react"
import { Stack, Typography } from "@mui/material"

export type LabeledFieldProps = Readonly<
    PropsWithChildren<{
        label: ReactNode
        bold?: boolean
        className?: string
        // Space between the label and the field. Defaults to ".5rem".
        gap?: string
    }>
>

export function LabeledField({ label, bold = true, className, gap = ".5rem", children }: LabeledFieldProps) {
    return (
        <Stack gap={gap} className={className}>
            <Typography variant="body1" fontWeight={bold ? "500" : undefined} color="text.secondary">
                {label}
            </Typography>
            {children}
        </Stack>
    )
}
